export default "__VITE_ASSET__BkoFh2df__"